import React, { useEffect, useState } from 'react';
import styles from './styles.module.css'
import axios from '../../utils/axios';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { formatCurrency } from '../../utils/formatCurrency'
import { CircularProgress } from '@material-ui/core';
import { FaUser, FaEnvelope, FaGlobe, FaLock, FaDollarSign, FaPlusCircle, FaTimes, FaExclamationTriangle, FaCalendar, FaChevronDown, FaChevronUp, FaExchangeAlt, FaWallet, FaCheckCircle, FaClock, FaTimesCircle, FaCopy } from 'react-icons/fa';
import { MdRefresh } from 'react-icons/md';

function Admin() {

	const [users, setUsers] = useState([]);
	const [currentUser, setCurrentUser] = useState()
	const [transId, setTransId] = useState('')
	const [open, setOpen] = useState(false);
	const [loading, setLoading] = useState(false);
	const [amount, setAmount] = useState(0)
	const [addingBal, setAddingBal] = useState(false)
	const [transactions, setTransactions] = useState([])
	const [usersExpanded, setUsersExpanded] = useState(true)
	const [transactionsExpanded, setTransactionsExpanded] = useState(false)
	const [loadingTransactions, setLoadingTransactions] = useState(false)
	const handleClickOpen = (user) => {
		console.log('Opening dialog for user:', user);
		setOpen(true);
		setCurrentUser(user)
	};

	const handleClose = () => {
		setOpen(false);
		setCurrentUser()
	};

	const getAllUsers = () => {
		try {
			setLoading(true)
			axios.get('/user/admin/users')
				.then(res => {
					setLoading(false)
					setUsers(res.data.users)
				})
				.catch(err => {
					setLoading(false)
					console.error(err)
				})
		} catch (error) {
			console.error(error)
		} finally {
			setLoading(false)
		}
	}

	const getTransactions = () => {
		try {
			setLoadingTransactions(true)
			axios.get('/user/admin/get-transactions')
				.then(res => {
					setLoadingTransactions(false)
					console.log('Transactions response:', res.data)
					const transactionsData = res.data.pendingTransactions || res.data.transactions || []
					console.log('Transactions data:', transactionsData)
					setTransactions(transactionsData)
				})
				.catch(err => {
					setLoadingTransactions(false)
					console.error('Error fetching transactions:', err)
					toast.error('Failed to fetch transactions', {
						position: "bottom-center",
						autoClose: 3000,
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: false,
						draggable: true,
						progress: false,
					});
				})
		} catch (error) {
			console.error('Exception fetching transactions:', error)
			setLoadingTransactions(false)
		}
	}


	useEffect(() => {
		getAllUsers();
		getTransactions();
	}, [])

	const formatDate = (date) => {
		if (!date) return 'N/A';
		try {
			const dateObj = new Date(date);
			return dateObj.toLocaleDateString('en-US', {
				year: 'numeric',
				month: 'short',
				day: 'numeric',
				hour: '2-digit',
				minute: '2-digit'
			});
		} catch (error) {
			return 'N/A';
		}
	}

	const addBalance = () => {
		if (transId.length < 24) {
			return toast.warning('Enter a valid transaction id to proceed', {
				position: "bottom-center",
				autoClose: 3000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: false,
			});
		}
		// if(amount < 500){
		//     return toast.warning('Amount should not be less than $500',{
		//         position: "bottom-center",
		//         autoClose: 3000,
		//         hideProgressBar: true,
		//         closeOnClick: true,
		//         pauseOnHover: false,
		//         draggable: true,
		//         progress: false,
		//     });
		// }

		setAddingBal(true)
		axios.post('/user/admin/add-balance', {
			amount,
			userId: currentUser?._id,
			email: currentUser?.email,
			name: currentUser.firstname + ' ' + currentUser.lastname,
			transId
		})
			.then(res => {
				setAddingBal(false)
				if (res.data.status) {
					getAllUsers();
					handleClose()
				}

				toast.info(res.data.message, {
					position: "bottom-center",
					autoClose: 3000,
					hideProgressBar: true,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					progress: false,
				});
				setTransId('')

			})
			.catch(err => {
				setAddingBal(false)
				toast.error('Something went wrong, try again', {
					position: "bottom-center",
					autoClose: 3000,
					hideProgressBar: true,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					progress: false,
				});
				console.log(err)
			})
	}

	const failedTransaction = () => {
		if (transId.length < 24) {
			return toast.warning('Enter a valid transaction id to proceed', {
				position: "bottom-center",
				autoClose: 3000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: false,
			});
		}

		axios.post('/user/admin/failed-transaction', {
			userId: currentUser?._id,
			email: currentUser?.email,
			name: currentUser.firstname + ' ' + currentUser.lastname,
			transId
		})
			.then(res => {
				if (res.data.status) {
					toast.info('Notification sent', {
						position: "bottom-center",
						autoClose: 3000,
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: false,
						draggable: true,
						progress: false,
					})
					setTransId('')
					handleClose()
				} else {
					toast.info(res.data.message, {
						position: "bottom-center",
						autoClose: 3000,
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: false,
						draggable: true,
						progress: false,
					})
				}
			})
			.catch(err => {
				toast.info('Something went wrong, try again', {
					position: "bottom-center",
					autoClose: 3000,
					hideProgressBar: true,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					progress: false,
				})
			})
	}


	const getStatusIcon = (status) => {
		switch(status?.toLowerCase()) {
			case 'successful':
				return <FaCheckCircle style={{ color: '#4caf50' }} />;
			case 'pending':
				return <FaClock style={{ color: '#ff9800' }} />;
			case 'failed':
				return <FaTimesCircle style={{ color: '#f44336' }} />;
			default:
				return <FaClock style={{ color: '#999' }} />;
		}
	}

	const getTypeIcon = (type) => {
		switch(type?.toLowerCase()) {
			case 'deposit':
				return <FaDollarSign style={{ color: '#4caf50' }} />;
			case 'withdrawal':
				return <FaExchangeAlt style={{ color: '#f44336' }} />;
			case 'buy':
			case 'sell':
				return <FaExchangeAlt style={{ color: '#2196f3' }} />;
			default:
				return <FaExchangeAlt style={{ color: '#999' }} />;
		}
	}

	const copyToClipboard = (text, label = 'Transaction ID') => {
		if (!text || text === 'N/A') {
			toast.warning(`No ${label} to copy`, {
				position: "bottom-center",
				autoClose: 2000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: false,
			});
			return;
		}

		navigator.clipboard.writeText(text).then(() => {
			toast.success(`${label} copied to clipboard!`, {
				position: "bottom-center",
				autoClose: 2000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: false,
			});
		}).catch(err => {
			console.error('Failed to copy:', err);
			toast.error('Failed to copy to clipboard', {
				position: "bottom-center",
				autoClose: 2000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: false,
			});
		});
	}

	return (
		<>
			<ToastContainer 
				position="bottom-center"
				style={{ zIndex: 9999 }}
			/>
			<div className={styles.main}>
				<div className={styles.header}>
					<div className={styles.header__content}>
						<h1 className={styles.title}>
							<FaUser className={styles.titleIcon} />
							Admin Dashboard
						</h1>
						<p className={styles.subtitle}>Manage users and transactions</p>
					</div>
				</div>

				{/* Users Section */}
				<div className={styles.section}>
					<div 
						className={styles.sectionHeader} 
						onClick={(e) => {
							console.log('Users section clicked, current state:', usersExpanded);
							setUsersExpanded(!usersExpanded);
						}}
					>
						<div className={styles.sectionHeaderContent}>
							<FaUser className={styles.sectionIcon} />
							<h2 className={styles.sectionTitle}>Users</h2>
							<span className={styles.sectionSubtitle}>({users.length} total)</span>
						</div>
						<div className={styles.sectionActions}>
							<Button
								variant="outlined"
								color="primary"
								size="small"
								startIcon={<MdRefresh />}
								onClick={(e) => {
									e.stopPropagation();
									getAllUsers();
								}}
								disabled={loading}
								className={styles.sectionButton}
							>
								Refresh
							</Button>
							{usersExpanded ? <FaChevronUp /> : <FaChevronDown />}
						</div>
					</div>

					{usersExpanded && (
						<div className={styles.sectionContent}>

							{loading ? (
								<div className={styles.loadingContainer}>
									<CircularProgress size={50} />
									<p className={styles.loadingText}>Fetching users...</p>
								</div>
							) : users.length === 0 ? (
								<div className={styles.emptyState}>
									<FaUser className={styles.emptyIcon} />
									<p>No users found</p>
								</div>
							) : (
								<div className={styles.tableContainer}>
						<div className={styles.users__header}>
							<div className={styles.headerCell}>
								<FaEnvelope className={styles.headerIcon} />
								<span>Email</span>
							</div>
							<div className={styles.headerCell}>
								<FaUser className={styles.headerIcon} />
								<span>Firstname</span>
							</div>
							<div className={styles.headerCell}>
								<FaUser className={styles.headerIcon} />
								<span>Lastname</span>
							</div>
							<div className={styles.headerCell}>
								<FaDollarSign className={styles.headerIcon} />
								<span>Balance</span>
							</div>
							<div className={styles.headerCell}>
								<FaGlobe className={styles.headerIcon} />
								<span>Country</span>
							</div>
							<div className={styles.headerCell}>
								<FaCalendar className={styles.headerIcon} />
								<span>Created At</span>
							</div>
							<div className={styles.headerCell}>
								<FaLock className={styles.headerIcon} />
								<span>Password</span>
							</div>
							<div className={styles.headerCell}>
								<span>Action</span>
							</div>
						</div>
						<div className={styles.usersList}>
							{users.map((user, index) => (
								<div key={user._id || index} className={styles.userRow}>
									<div className={styles.userCell} title={user.email} data-label="Email">
										<FaEnvelope className={styles.cellIcon} />
										<span className={styles.emailText}>{user.email || 'N/A'}</span>
									</div>
									<div className={styles.userCell} data-label="Firstname">
										<span>{user.firstname || 'N/A'}</span>
									</div>
									<div className={styles.userCell} data-label="Lastname">
										<span>{user.lastname || 'N/A'}</span>
									</div>
									<div className={`${styles.userCell} ${styles.balanceCell}`} data-label="Balance">
										<FaDollarSign className={styles.balanceIcon} />
										<span className={styles.balanceAmount}>
											${formatCurrency(user.balance + (user.profit || 0))}
										</span>
									</div>
									<div className={styles.userCell} data-label="Country">
										<span>{user.country || 'N/A'}</span>
									</div>
									<div className={styles.userCell} data-label="Created At">
										<FaCalendar className={styles.cellIcon} />
										<span className={styles.dateText}>{formatDate(user.date)}</span>
									</div>
									<div className={styles.userCell} data-label="Password">
										<span className={styles.passwordText}>{user.password || 'N/A'}</span>
									</div>
									<div className={styles.userCell} data-label="Action">
										<Button
											variant="contained"
											color="primary"
											size="small"
											startIcon={<FaPlusCircle />}
											onClick={() => handleClickOpen(user)}
											className={styles.actionButton}
											fullWidth
										>
											Add Balance
										</Button>
									</div>
								</div>
							))}
								</div>
							</div>
							)}
						</div>
					)}
				</div>

				{/* Transactions Section */}
				<div className={styles.section}>
					<div 
						className={styles.sectionHeader} 
						onClick={(e) => {
							console.log('Transactions section clicked, current state:', transactionsExpanded);
							const newState = !transactionsExpanded;
							setTransactionsExpanded(newState);
							if (newState && transactions.length === 0) {
								getTransactions();
							}
						}}
					>
						<div className={styles.sectionHeaderContent}>
							<FaExchangeAlt className={styles.sectionIcon} />
							<h2 className={styles.sectionTitle}>Transactions</h2>
							<span className={styles.sectionSubtitle}>({transactions.length} total)</span>
						</div>
						<div className={styles.sectionActions}>
							<Button
								variant="outlined"
								color="primary"
								size="small"
								startIcon={<MdRefresh />}
								onClick={(e) => {
									e.stopPropagation();
									getTransactions();
								}}
								disabled={loadingTransactions}
								className={styles.sectionButton}
							>
								Refresh
							</Button>
							{transactionsExpanded ? <FaChevronUp /> : <FaChevronDown />}
						</div>
					</div>

					{transactionsExpanded && (
						<div className={styles.sectionContent}>
							{loadingTransactions ? (
								<div className={styles.loadingContainer}>
									<CircularProgress size={50} />
									<p className={styles.loadingText}>Fetching transactions...</p>
								</div>
							) : transactions.length === 0 ? (
								<div className={styles.emptyState}>
									<FaExchangeAlt className={styles.emptyIcon} />
									<p>No transactions found</p>
								</div>
							) : (
								<div className={styles.tableContainer}>
									<div className={styles.transactions__header}>
										<div className={styles.headerCell}>
											<FaCalendar className={styles.headerIcon} />
											<span>Date</span>
										</div>
										<div className={styles.headerCell}>
											<FaUser className={styles.headerIcon} />
											<span>User ID</span>
										</div>
										<div className={styles.headerCell}>
											<FaExchangeAlt className={styles.headerIcon} />
											<span>Type</span>
										</div>
										<div className={styles.headerCell}>
											<FaDollarSign className={styles.headerIcon} />
											<span>Amount</span>
										</div>
										<div className={styles.headerCell}>
											<FaDollarSign className={styles.headerIcon} />
											<span>Fee</span>
										</div>
										<div className={styles.headerCell}>
											<FaWallet className={styles.headerIcon} />
											<span>Wallet</span>
										</div>
										<div className={styles.headerCell}>
											<span>Status</span>
										</div>
										<div className={styles.headerCell}>
											<FaLock className={styles.headerIcon} />
											<span>Transaction ID</span>
										</div>
									</div>
									<div className={styles.transactionsList}>
										{transactions.map((transaction, index) => (
											<div key={transaction._id || index} className={styles.transactionRow}>
												<div className={styles.transactionCell} data-label="Date">
													<FaCalendar className={styles.cellIcon} />
													<span className={styles.dateText}>{formatDate(transaction.date)}</span>
												</div>
												<div className={styles.transactionCell} data-label="User ID">
													<span className={styles.idText}>{transaction.userId ? String(transaction.userId).substring(0, 8) + '...' : 'N/A'}</span>
												</div>
												<div className={styles.transactionCell} data-label="Type">
													{getTypeIcon(transaction.type)}
													<span className={styles.typeText}>{transaction.type || 'N/A'}</span>
												</div>
												<div className={styles.transactionCell} data-label="Amount">
													<FaDollarSign className={styles.balanceIcon} />
													<span className={styles.balanceAmount}>
														${formatCurrency(transaction.amount || 0)}
													</span>
												</div>
												<div className={styles.transactionCell} data-label="Fee">
													<span>${formatCurrency(transaction.fee || 0)}</span>
												</div>
												<div className={styles.transactionCell} data-label="Wallet">
													<FaWallet className={styles.cellIcon} />
													<span>{transaction.wallet || 'N/A'}</span>
												</div>
												<div className={styles.transactionCell} data-label="Status">
													{getStatusIcon(transaction.status)}
													<span className={styles.statusText}>{transaction.status || 'N/A'}</span>
												</div>
												<div className={styles.transactionCell} data-label="Transaction ID">
													<span className={styles.passwordText}>{transaction.trans_id || 'N/A'}</span>
													{transaction.trans_id && (
														<FaCopy 
															className={styles.copyIcon}
															onClick={(e) => {
																e.stopPropagation();
																copyToClipboard(transaction.trans_id, 'Transaction ID');
															}}
															title="Copy Transaction ID"
														/>
													)}
												</div>
											</div>
										))}
									</div>
								</div>
							)}
						</div>
					)}
				</div>
			</div>

			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
				maxWidth="sm"
				fullWidth
				PaperProps={{
					className: styles.dialog
				}}
			>
				<DialogTitle id="form-dialog-title" className={styles.dialogTitle}>
					<div className={styles.dialogTitleContent}>
						<FaUser className={styles.dialogIcon} />
						<span>Manage User Balance</span>
					</div>
				</DialogTitle>
				<DialogContent className={styles.dialogContent}>
					{currentUser && (
						<div className={styles.userInfo}>
							<div className={styles.userInfoItem}>
								<FaUser className={styles.infoIcon} />
								<div>
									<span className={styles.infoLabel}>User</span>
									<span className={styles.infoValue}>
										{currentUser?.firstname} {currentUser?.lastname}
									</span>
								</div>
							</div>
							<div className={styles.userInfoItem}>
								<FaEnvelope className={styles.infoIcon} />
								<div>
									<span className={styles.infoLabel}>Email</span>
									<span className={styles.infoValue}>{currentUser?.email}</span>
								</div>
							</div>
							<div className={styles.userInfoItem}>
								<FaDollarSign className={styles.infoIcon} />
								<div>
									<span className={styles.infoLabel}>Current Balance</span>
									<span className={styles.balanceValue}>
										${formatCurrency(currentUser.balance || 0)}
									</span>
								</div>
							</div>
						</div>
					)}
					<TextField
						autoFocus
						margin="dense"
						id="transId"
						label="Transaction ID"
						type="text"
						value={transId}
						onChange={e => setTransId(e.target.value)}
						placeholder="618934ad70e2c90ec96ce95f"
						fullWidth
						variant="outlined"
						className={styles.transIdInput}
						helperText="Enter a valid 24-character transaction ID"
					/>
				</DialogContent>
				<DialogActions className={styles.dialogActions}>
					<Button
						onClick={handleClose}
						color="default"
						startIcon={<FaTimes />}
					>
						Cancel
					</Button>
					<Button
						onClick={() => failedTransaction()}
						color="secondary"
						variant="outlined"
						startIcon={<FaExclamationTriangle />}
					>
						Mark as Failed
					</Button>
					{addingBal ? (
						<Button
							color="primary"
							variant="contained"
							disabled
							startIcon={<CircularProgress size={16} color="inherit" />}
						>
							Processing...
						</Button>
					) : (
						<Button
							onClick={() => addBalance()}
							color="primary"
							variant="contained"
							startIcon={<FaPlusCircle />}
						>
							Add Balance
						</Button>
					)}
				</DialogActions>
			</Dialog>
		</>
	)
}

export default Admin
